import React, { useEffect, useState } from 'react';
import { getFollowing } from './ApiCalls';

export default function Following(user) {
  const [following, setfollowing] = useState([]);

  useEffect(() =>{
    getFollowing(user.username).then((events) => {
      if(events.message !== 'Not Found')
      setfollowing(events);
      else
      setfollowing([])
    });
  }, [user.username]);

  function changeUser(event, username){
    event.preventDefault();
    user.setUser(username);
  }

  return(
    <div className='center follow-gap flex'>
      {following.map((follow) => (
        <div className='follow-border' key={follow.login}>
          <img className={follow.type ==='Organization'? 'follow-img enterprise-img' : 'follow-img'}  src={follow.avatar_url} alt='GitHub user profile'></img>
          <p className='sub-color padding-bottom10'>{follow.login}</p>
          <div className='center'>
          <a href={follow.html_url} target="_blank" rel="noreferrer">
            <button className='button-repo' onClick={(event) => changeUser(event, follow.login)}>Learn More</button>
          </a>
          <a href={follow.html_url} target="_blank" rel="noreferrer">
            <button className='button-repo'>Visit GitHub</button>
          </a>
        </div>
      </div>
      ))}
    </div>      
  )
} 
